import { createSlice } from '@reduxjs/toolkit'
export const userSlice = createSlice({
  name: 'user',
  initialState: {
    value: {
      username:'',
      startupcode: '',
    },
  },
  reducers: {
    resetUserAll: state => {
      state.value = { username: "", startupcode: "" };
    },
    resetUserName: state => {
      state.value.username = ""
    },
    resetUserStartupcode: state => {
      state.value.startupcode = ""
    },
    updateUser: (state, action) => { 
      // state.value = action.payload
      state.value = { ...state.value, ...action.payload };
    },
  }
})

// Action creators are generated for each case reducer function
export const { 
  resetUserAll,
  resetUserName,
  resetUserStartupcode,
  updateUser, 
} = userSlice.actions
// reducer 要放入 store
export default userSlice.reducer